import { useContext, useState } from "react"
import { UserContext } from "../context/userContext"
import { LoaderSmall } from "./Loaders"
import _ from "lodash"

import { gql, useQuery } from "@apollo/client"

export default function CustomTemplateName({ parent, original_label }) {
  const userCtx = useContext(UserContext)
  const [label, setLabel] = useState("")
  const [loading, setLoading] = useState(true)

  const GET_LABEL = gql`
    query GetLabel($parent: String!, $enterprise_id: ID!) {
      label(parent: $parent, enterprise_id: $enterprise_id) {
        data
      }
    }
  `
  useQuery(GET_LABEL, {
    variables: {
      parent: parent,
      enterprise_id: userCtx.session.user.enterprise_id,
    },
    fetchPolicy: "network-only",
    skip: !userCtx,
    onCompleted: async (data) => {
      let parsedData
      try {
        parsedData = JSON.parse(data.label.data)
        setLabel(parsedData)
        setLoading(false)
      } catch (error) {
        parsedData = ""
      }
    },
  })

  if (loading) return <LoaderSmall />

  return _.isEmpty(label) ? original_label : label
}
